import React, { useContext } from 'react';
import { connect } from 'react-redux';

import {
  Row,
  Col,
  Accordion,
  Card,
  Image,
  useAccordionToggle,
  AccordionContext
} from 'react-bootstrap';

import classes from './faqspage.module.css';
import button_collapsed from '../../assets/images/button-collapsed.svg';
import button_expanded from '../../assets/images/button-expanded.svg';


const Item = ({ data }) => {
  function ContextAwareToggle({ children, eventKey, callback }) {
    const currentEventKey = useContext(AccordionContext);
    const decoratedOnClick = useAccordionToggle(
      eventKey,
      () => callback && callback(eventKey),
    );
    const isCurrentEventKey = currentEventKey === eventKey;
    return (
      <Image
        className="float-right button-toggle"
        src={(isCurrentEventKey) ? button_collapsed : button_expanded}
        height="20"
        width="20"
        onClick={decoratedOnClick} />
    );
  }

  return (
    <React.Fragment>
      <Card className={classes.accordionCard} style={{ border: '0' }}>
        <Card.Header>
          <Row>
            <Col xs={11} className={classes.accordionTitle}>{data.title}</Col>
            <Col>
              <ContextAwareToggle eventKey={data.id} />
            </Col>
          </Row>
        </Card.Header>
        <Accordion.Collapse eventKey={data.id}>
          <Card.Body className={classes.alignContent}>
            <div dangerouslySetInnerHTML={{ __html: data.content }} />
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </React.Fragment>
  );
}

const mapStateProps = (state) => {
  return {}
}

export default connect(
  mapStateProps,
  {}
)(Item);